module.exports = __webpack_public_path__ + "static/media/Weightlifter.0c4b7d44.jpg";